import { formatSearchCount } from "@/utils/formatSearchCount";

export const generateTabLabel = (
  label: string,
  count: number,
  isComplete: boolean,
) => {
  return isComplete ? `${label}(${formatSearchCount(count)})` : label;
};
